@if (!mapService.isDiscreteEnabled() && (flagService.getFlags$() | async)?.[FeatureFlags.EXPORT_GEOTIFF]) {
    <div [matTooltip]="getTooltip()" matTooltipPosition="right">
        <button
                id="export-geotiff-toolbar-button"
                [disabled]="!exportGeoTiffEnabled || swipeEnabled"
                matIconButton
                class="mat-icon-toggle-button"
                [class.selected]="displayPanel"
                type="button"
                (click)="togglePanelDisplay()">
            <mat-icon>get_app</mat-icon>
        </button>
    </div>
}

<div class="toolbar-panel-container" [hidden]="!displayPanel">
    <h6>Download GeoTIFF</h6>
    <p>Draw around the area to download</p>
    <div class="row my-2">
        <div class="col-2" matTooltip="Draw polygon" matTooltipPosition="below">
            <button
                    id="polygon-button"
                    type="button"
                    matIconButton
                    (click)="selectTool(toolsIds.SELECTION_POLYGON)"
                    [class.selected]="selectedTool && selectedTool.id === toolsIds.SELECTION_POLYGON">
                <mat-icon svgIcon="poly"></mat-icon>
            </button>
        </div>
        <div class="col-2" matTooltip="Draw square" matTooltipPosition="below">
            <button
                    id="square-button"
                    type="button"
                    matIconButton
                    (click)="selectTool(toolsIds.SELECTION_SQUARE)"
                    [class.selected]="selectedTool && selectedTool.id === toolsIds.SELECTION_SQUARE">
                <mat-icon svgIcon="box"></mat-icon>
            </button>
        </div>
        <div class="col-2" matTooltip="Draw circle" matTooltipPosition="below">
            <button
                    id="circle-button"
                    type="button"
                    matIconButton
                    (click)="selectTool(toolsIds.SELECTION_CIRCLE)"
                    [class.selected]="selectedTool && selectedTool.id === toolsIds.SELECTION_CIRCLE">
                <mat-icon svgIcon="circle"></mat-icon>
            </button>
        </div>
        <div class="col-2" matTooltip="Edit shape" matTooltipPosition="below">
            <button id="edit-button" type="button" matIconButton [disabled]="!selectionGeometry" (click)="toggleEdit()"
                    [class.selected]="editActionEnabled">
                <mat-icon svgIcon="edit"></mat-icon>
            </button>
        </div>
        <div class="col-2" matTooltip="Clear workspace" matTooltipPosition="below">
            <button id="clear-button" type="button" matIconButton (click)="clearWorkspace()"
                    [disabled]="!selectionGeometry">
                <mat-icon svgIcon="clear"></mat-icon>
            </button>
        </div>
    </div>
    <mat-checkbox class="my-2" [(ngModel)]="showDimensions" (change)="changeDimensionVisibility($event)">Show
        dimensions
    </mat-checkbox>
    <p>Or import a boundary file:</p>
    <button matButton="elevated" class="w-100" (click)="openUploadDialog()">
        <mat-icon>backup</mat-icon>
        Click here to add data
    </button>
    <mat-divider class="my-4"></mat-divider>
    <h6 class="my-2">Output settings:</h6>
    <div class="d-flex">
        Current download size:&nbsp;
        @if (tilesSelected) {
            <p  [class.multi-export-tiles-limit-exceeded]="this.multiExportTilesLimitExceeded"
                    [class.tiles-limit-exceeded]="this.tilesLimitExceeded && !this.multiExportTilesLimitExceeded">
                {{ tilesSelected }} tiles
            </p>
        }
    </div>

    <div class="mat-toolbar-filters" [formGroup]="exportForm">
        <div>
            <mat-label>Zoom</mat-label>
            <mat-form-field class="form-ultra-slim">
                <mat-select formControlName="zoom" [(value)]="selectedZoom" (selectionChange)="changeZoom($event)">
                    @for (zoom of zoomsLevels; track zoom.value) {
                        <mat-option [value]="zoom.value">
                            {{ zoom.desc }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div>
            <mat-label>Clip</mat-label>
            <mat-form-field class="form-ultra-slim">
                <mat-select formControlName="clip" [(value)]="selectedClipMode"
                            (selectionChange)="changeClipMode($event)">
                    @for (v of extractValues; track v.value) {
                        <mat-option [value]="v.value">{{ v.label }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <mat-divider class="my-4"></mat-divider>
    <button
            (click)="downloadGeoTiff()"
            [disabled]="!selectionGeometry || tilesLimitExceeded || multipleCollections || editActionEnabled"
            matButton="filled" color="primary"
            class="w-100">
        DOWNLOAD GEOTIFF
    </button>

    @if (downloadingGeoTiff) {
        <div class="my-2">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
    }

    @if (warningMessage) {
        <div class="geotiff-info-panel" [class.limit]="multiExportTilesLimitExceeded"
             [class.warning]="!multiExportTilesLimitExceeded">
            <mat-icon>warning</mat-icon>
            <span class="message-text">
            {{ warningMessage }}
                <span class="link-btn" *ngIf="tilesLimitExceeded && !multiExportTilesLimitExceeded"
                      (click)="openDialogMultiDownloadGeoTIFF()">
              download multiple GeoTIFFs
            </span>
          </span>
        </div>
    }
    @if (errorMessage) {
        <div class="geotiff-info-panel error">
            <mat-icon>error</mat-icon>
            <span class="message-text">{{ errorMessage }}</span>
        </div>
    }
</div>
